import { createAsyncThunk } from '@reduxjs/toolkit';

import { removeUndefined } from 'commonUtils/removeUndefined';

import { sendSentryClientErrorOnce } from 'shared/lib';
import type { TLoansContactData } from 'shared/types/TLoansService';

import { selectAllFormFields } from 'entities/creditForm';
import { collectWLOtherDataSelector } from 'entities/whiteLabels';

import { sendLoansContactDataApi } from '../model/sendLoansContactData.query';

import { formDataToLoansContactCustomerAdapter } from './formDataToLoansContactCustomerAdapter';

type TPayload = {
  sourceUrl: string;
  deviceType: TLoansContactData['client']['deviceType'];
  channel: string;
};

export const sendContactThunk = createAsyncThunk<
  void,
  TPayload,
  { state: Pick<Store, 'user' | 'creditForm' | 'whiteLabel'> }
>('sendContact/sendCalculationThunk', async (payload, { dispatch, getState }) => {
  const { sourceUrl, deviceType, channel } = payload;
  const formFields = selectAllFormFields(getState());
  const otherWlData = collectWLOtherDataSelector(getState());

  const customer = formDataToLoansContactCustomerAdapter(formFields);

  const data: TLoansContactData = {
    customer,
    client: {
      sourceUrl,
      deviceType,
      channel,
    },
    other: { ...otherWlData },
  };

  try {
    await dispatch(sendLoansContactDataApi.endpoints.sendLoansContactData.initiate(removeUndefined(data))).unwrap();
  } catch (error) {
    sendSentryClientErrorOnce('sendContactThunk', error);
  }
});
